export const salutationsMasters: string[] = ['Mr.', 'Ms.', 'M/S.', 'Mrs.'];
export const applicantStatusMasters: { [key: string]: string } = {
  Individual: 'Individual (Resident)',
  NRI: 'Individual (NRI)',
};

export const maritalStatusMaster: { [key: string]: string } = {
  single: 'Single',
  married: 'Married',
};

export const yesAndNoMasters: { [key: string]: string } = {
  yes: 'Yes',
  no: 'No',
};
export const yesAndNoTrueAndFalseMasters: { [key: string]: string } = {
  true: 'Yes',
  false: 'No',
};
export const nationalitiesMasters: string[] = ['Indian', 'Others'];
export const occupationDetailsMasters: { [key: string]: string } = {
  private_sector_service: 'PRIVATE SECTOR SERVICE',
  public_sector: 'PUBLIC SECTOR',
  govternment_service: 'GOVERNMENT SERVICE',
  business: 'BUSINESS',
  professional: 'PROFESSIONAL',
  retired: 'RETIRED',
  housewife: 'HOUSEWIFE',
  proprietorship: 'PROPRIETORSHIP',
  gurdian: 'GUARDIAN',
  others: 'OTHERS',
};

export const grossAnnualMasters: { [key: string]: string } = {
  below_one_crore: 'BELOW 1 CRORE',
  one_crore_to_five_crores: '1 CRORE - 5 CRORES',
  five_crores_to_ten_crores: '5 CRORES - 10 CRORES',
  ten_crore_and_above: '10 CRORES & ABOVE',
};

export const PEPsMasters: string[] = ['I am PEP', 'I am Related to PEP', 'Not Applicable'];

export const addressTypesMasters: string[] = [
  'Resident/Business',
  'Resident',
  'Business',
  'Registered Office',
  'Unspecified',
];

export const genderMasters: string[] = ['Male', 'Female', 'Others'];

export const IdentityProofsMasters: string[] = [
  'Photo PAN Card',
  'Passport',
  "Voter's ID",
  'Driving License',
  'Aadhar Card',
];

export const AddressProofsMasters: string[] = [
  'Passport',
  "Voter's ID",
  'Ration Card',
  'Electricity Bill',
  'Landline/Telephone Bill',
  'Gas Bill',
  'Latest Bank Statement/Passbook',
  'Latest Depository Account Statement',
];

export const BankAccountProofsMasters: string[] = [
  'Bank Statement with IFSC printed on it',
  'Cancelled cheque leaf verified',
  'Letter from the bank giving account details',
  'Passbook (showing bank account details)',
];

export const DrawDownMasters: number[] = [1, 2, 3, 4];

export const filterApplicationTypes = [
  { key: 'individual', value: 'Individual (Resident)' },
  { key: 'non_individual', value: 'Non-Individual' },
  { key: 'poa', value: 'Individual (POA)' },
  { key: 'nri', value: 'Individual (NRI)' },
  { key: 'nri_poa', value: 'Individual (NRI-POA)' },
  { key: 'non_individual_poa', value: 'Non-Individual (POA)' },
];

export const ModeOfHoldingTypes = [
  { key: 'single', value: 'Single' },
  { key: 'joint', value: 'Joint' },
  { key: 'either or survivor', value: 'Either or Survivor' },
];

export const IMAGE_UPLOAD_FORMATS = ['image/jpeg', 'application/pdf', 'image/png', 'image/jpg'];

export const INVESTOR_IMAGE_UPLOAD_FORMATS = ['image/png', 'image/jpg', 'image/jpeg'];

export const APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};

export const SUPPORT_STATUS: { [key: string]: string } = {
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  // approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by Trustee',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};

export const POA_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to AIF approver',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const ESIGN_STATUS: { [key: string]: string } = {
  NOT_GENERATED: 'notgenerated',
  PENDING_SIGNATURE: 'pendingsignature',
  SIGNED: 'signed',
  EXPIRED: 'expired',
};

export enum USER_ROLES {
  SUPER_ADMIN = 'superadmin',
  AMC_ADMIN = 'amcadmin',
  RM = 'rm',
  DISTRIBUTOR = 'distributor',
  INVESTOR = 'investor',
  FUND_MANAGER = 'fundmanager',
  TRUSTEE = 'trustee',
  WITNESS = 'witness',
  APPLICATION = 'application',
  SUBDISTRIBUTOR = 'subdistributor',
  POAAPPROVER = 'poaapprover',
  AMCAPPROVER = 'amcapprover',
  AUTHORISEDSIGNATORY = 'authorisedsignatory',
  GROUPSIGNATORY = 'groupsignatory',
}

export const ApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } = {
  [USER_ROLES.POAAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_poa_approver: 'Pending',
  },
  [USER_ROLES.AMCAPPROVER]: {
    ...POA_APPLICATION_STATUS,
    sent_to_amc_approver: 'Pending',
  },
};

export const Relations = [
  'Mother',
  'Father',
  'Daughter',
  'Son',
  'Spouse',
  'Brother',
  'Sister',
  'Others',
];

export const NomineeRelations = [
  'MOTHER',
  'FATHER',
  'DAUGHTER',
  'SON',
  'SPOUSE',
  'BROTHER',
  'SISTER',
  'OTHERS',
];

export const adminSupportMaster: { [key: string]: string } = {
  unlock_user: 'Unlock User',
  check_whitelisted: 'Check Whitelisted',
  whitelist_user: 'Whitelist User',
  unwhitelist_user: 'Unwhitelist User',
  change_expired_status: 'Change Expired Status',
  change_status_to_draft: 'Change Status to draft',
  process_signed_applications: 'Process Signing Applications',
};

export const ENABLE_PROCESS_SIGNING_APPLICATIONS = true;

export const IS_DOB_APPLICABLE_FOR_AMC = true;

export const REJECTED_ROLES: { [key: string]: string } = {
  poaapprover: 'POA Approver',
  amcapprover: 'AIF Approver',
};

export const investorTypeMasters: { [key: string]: string } = {
  corporate: 'Corporate',
  trust: 'Trust',
  partnership_firm: 'Partnership Firm',
  huf: 'HUF',
  govt_bodies: 'Army/ Government Bodies',
  registered_society: 'Registered Society',
  fii_fpi: 'FII/FPI',
  bank: 'Bank',
  institutional_investor: 'Institutional Investor',
  unincorporated_or_body_of_individuals: 'Unincorporated association or a body of individuals',
  foreign_entity: 'Foreign Entity',
  proprietorship_firm: 'Proprietorship Firm',
};
export const IS_PENNYDROP_APPLICABLE_FOR_AMC = true;

export const getGroupNameMaster = ['Group-A', 'Group-B', 'Group-C'];

export const NON_INDIVIDUAL_APPLICATION_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to AIF approver',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
  approved_by_fundmanager: 'Approved by investment manager',
  approved_by_trustee: 'Approved by trustee',
  invitationexpired: 'Invitation Expired',
  signed: 'Completed',
  completed: 'Completed',
  rejected: 'Rejected',
};

export const CpUboCodesMaster: { [key: string]: string } = {
  C01: '- CP of legal person-ownership',
  C02: '- CP of legal person-other means',
  C03: '- CP of legal person-senior managing official',
  C04: '- CP of legal arrangement-trust-settlor',
  C05: '- CP of legal arrangement-trust-trustee',
  C06: '- CP of legal arrangement-trust-protector',
  C07: '- CP of legal arrangement-trust-beneficiary',
  C08: '- CP of legal arrangement-trust-other',
  C09: '- CP of legal arrangement-trust-other-settlor-equivalent',
  C10: '- CP of legal arrangement-trust-other-trustee-equivalent',
  C11: '- CP of legal arrangement-trust-other-protector-equivalent',
  C12: '- CP of legal arrangement-trust-other-beneficiary-equivalent',
  C13: '- CP of legal arrangement-trust-other-other-equivalent',
  C14: '- Unknown',
};
export const controllingPersonsNationalitiesMasters: string[] = ['Indian', 'Others'];

//Application types
export enum APPLICATION_TYPE {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
}

export const AMC_APPROVER_CHECK_FOR_INDIVIDUAL = true; // this parameter is used to check application should be sent to approver first before investor

export const ENABLE_EMAIL_OTP = true;

export const APPLICATION_STATUS_AMCAPPROVER_individual: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_amc_approver: 'Sent to AIF approver',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
};
export const IndividualApplicationStatusBasedOnRole: { [key: string]: { [key: string]: string } } =
  {
    [USER_ROLES.AMCAPPROVER]: {
      ...APPLICATION_STATUS_AMCAPPROVER_individual,
      sent_to_amc_approver: 'Pending',
    },
  };

export const APPLICATION_LISTING_STATUS: { [key: string]: string } = {
  draft: 'Draft',
  sent_to_applicant1: 'Sent to 1st applicant',
  approved_by_applicant1: 'Approved by 1st Applicant',
  approved_by_applicant2: 'Approved by 2nd Applicant',
  approved_by_applicant3: 'Approved by 3rd Applicant',
  approved_by_trustee: 'Approved by Trustee',
  approved_by_fundmanager: 'Approved by investment manager',
  invitationexpired: 'Invitation Expired',
  completed: 'Completed',
  signed: 'Completed',
  rejected: 'Rejected',
  sent_to_poa_approver: 'Sent to POA approver',
  sent_to_amc_approver: 'Sent to AIF approver',
  sent_to_authorised_signatories: 'Sent to authorised signatories',
  approved_by_authorised_signatories: 'Approved by authorised signatories',
};

export enum APPLICATION_TYPE_FOR_DOCUMENTS {
  INDIVIDUAL = 'individual',
  NON_INDIVIDUAL = 'non_individual',
  INDIVIDUAL_POA = 'individual_poa',
  NRI = 'nri',
  NRI_POA = 'nri_poa',
  NOMINEE_DOC = 'nominee',
  NOMINEE_GUARDIAN = 'nomineeGuardian',
}
export const BankAccountTypeMaster: { [key: string]: string } = {
  Current: 'CURRENT',
  Savings: 'SAVING',
};
export const NRIBankAccountTypeMaster: { [key: string]: string } = {
  NRE: 'NRE',
  NRO: 'NRO',
};
export const DistributorTypesForUserManageMent: { [key: string]: string } = {
  Individual: 'individual',
  Company: 'company',
};

export const ENABLE_KRA_DOCUMENT_FETCH = false;

export const SALT = 'F2lNZWFxUH';
export const SALT2 = 'WTVPJel6dTGVocF';

export const ONBOARDING_OPTIONS: { [key: string]: string } = {
  otp: 'OTP',
  email_consent: 'Email Consent',
};

export const EmailConsentStatusMaster: { [key: string]: string } = {
  pending: 'Pending',
  rejected: 'Rejected',
  approved: 'Approved',
  revoked: 'Revoked',
};

export const ENABLE_Email_Consent = false;

export const BloodRelations = ['Father', 'Mother', 'Son', 'Daughter', 'Spouse'];

export const COMPANIES_MASTER: { [key: string]: string } = { Kotak: 'kotak', Other: 'other' };

export const COMPANIES_MASTER_FORMETED_OBJECT = Object.keys(COMPANIES_MASTER).map((item) => ({
  key: item,
  value: COMPANIES_MASTER[item],
}));

export const IdTypeMasters: string[] = ['TIN', 'OTHERS'];

export const ReasonMaster: { [key: string]: { code: string; description: string } } = {
  reason_a: {
    code: 'Reason A',
    description:
      'The country where the Account Holder is liable to pay tax does not issue TIN to its residents.',
  },
  reason_b: {
    code: 'Reason B',
    description:
      'No TIN required [Select this reason only if the authorities of the respective country of tax residence do not required the TIN to be collected].',
  },
  reason_c: { code: 'Reason C', description: 'Please specify incase there is anyother reason.' },
};

export const ModeOfOperationMaster: { [key: string]: string } = {
  joint: 'Joint',
  anyone: 'Anyone',
  'as per br': 'As per BR',
};
export const ModeOfHoldingMaster: { [key: string]: string } = {
  joint: 'Joint',
  'either or survivor': 'Either or Survivor',
};

export const exemptionCodeForUSInfo = [
  {
    code: 'A',
    description:
      'An organization exempt from tax under section 501(a) or any individual retirement plan as defined in section 7701(a)(37)',
  },
  {
    code: 'B',
    description: 'The United States or any of its agencies or instrumentalities',
  },
  {
    code: 'C',
    description:
      'A state, the District of Columbia, a possession of the United States, or any of their political subdivisions or instrumentalities',
  },
  {
    code: 'D',
    description:
      'A corporation the stock of which is regularly traded on one or more established securities markets, as described in Reg. section 1.1472-1(c)(1)(I)',
  },
  {
    code: 'E',
    description:
      'A corporation that is a member of the same expanded affiliated group as a corporation described in Reg. section 1.1472-1(c)(1)(I)',
  },
  {
    code: 'F',
    description:
      'A dealer in securities, commodities, or derivative financial instruments (including notional principal contracts, futures, forwards, and options) that is registered as such under the laws of the United States or any state',
  },
  {
    code: 'G',
    description: 'A real estate investment trust',
  },
  {
    code: 'H',
    description:
      'A regulated investment company as defined in section 851 or an entity registered at all times during the tax year under the Investment Company Act of 1940',
  },
  {
    code: 'I',
    description: 'A common trust fund as defined in section 584(a)',
  },
  {
    code: 'J',
    description: 'A bank as defined in section 581',
  },
  {
    code: 'K',
    description: 'A broker',
  },
  {
    code: 'L',
    description: 'A trust exempt from tax under section 664 or described in section 4947(a)(1)',
  },
  {
    code: 'M',
    description: 'A tax exempt trust under a section 403(b) plan or section 457(g) plan',
  },
];
export const giinNotRequiredCodeInfo = [
  {
    code: '01',
    description: 'Governmental Entity, International Organization or Central Bank',
  },
  {
    code: '02',
    description:
      'Treaty Qualified Retirement Fund; a Broad Participation Retirement Fund; a Narrow Participation Retirement Fund; or a Pension Fund of a Governmental Entity, International Organization or Central Bank',
  },
  {
    code: '03',
    description:
      "Non-public fund of the armed forces, an employees' state insurance fund, a gratuity fund or a provident fund",
  },
  {
    code: '04',
    description: 'Entity is an Indian FI solely because it is an investment entity',
  },
  {
    code: '05',
    description: 'Qualified credit card issuer',
  },
  {
    code: '06',
    description: 'Investment Advisors and Investment Managers',
  },
  {
    code: '07',
    description: 'Exempt collective investment vehicle',
  },
  {
    code: '08',
    description: 'Trustee of an Indian Trust',
  },
  {
    code: '09',
    description: 'FI with a local client base',
  },
  {
    code: '10',
    description: 'Non-registering local banks',
  },
  {
    code: '11',
    description: 'FFI with only Low-Value Accounts',
  },
  {
    code: '12',
    description: 'Sponsored investment entity and controlled foreign corporation',
  },
  {
    code: '13',
    description: 'Sponsored, Closely Held Investment Vehicle',
  },
  {
    code: '14',
    description: 'Owner Documented FFI',
  },
];

export const nFFECategoryInfo = [
  {
    code: '01',
    description:
      'Less than 50 percent of the NFFE’s gross income for the preceding calendar year or other appropriate reporting period is passive income and less than 50 percent of the assets held by the NFFE during the preceding calendar year or other appropriate reporting period are assets that produce or are held for the production of passive income;',
  },
  {
    code: '02',
    description:
      'The NFFE is a government (other than the U.S. government), a political subdivision of such government (which, for the avoidance of doubt, includes a state, province, county, or municipality), or a public body performing a function of such government or a political subdivision thereof, a government of a U.S. Territory, an international organization, a non-U.S. central bank of issue, or an Entity wholly owned by one or more of the foregoing;',
  },
  {
    code: '03',
    description:
      'Substantially all of the activities of the NFFE consist of holding (in whole or in part) the outstanding stock of, or providing financing and services to, one or more subsidiaries that engage in trades or businesses other than the business of a Financial Institution, except that an entity shall not qualify for NFFE status if the entity functions (or holds itself out) as an investment fund, such as a private equity fund, venture capital fund, leveraged buyout fund, or any investment vehicle whose purpose is to acquire or fund companies and then hold interests in those companies as capital assets for investment purposes;',
  },
  {
    code: '04',
    description:
      'The NFFE is not yet operating a business and has no prior operating history, but is investing capital into assets with the intent to operate a business other than that of a Financial Institution, provided that the NFFE shall not qualify for this exception after the date that is 24 months after the date of the initial organization of the NFFE;',
  },
  {
    code: '05',
    description:
      'The NFFE was not a Financial Institution in the past five years, and is in the process of liquidating its assets or is reorganizing with the intent to continue or recommence operations in a business other than that of a Financial Institution;',
  },
  {
    code: '06',
    description:
      'The NFFE primarily engages in financing and hedging transactions with, or for, Related Entities that are not Financial Institutions, and does not provide financing or hedging services to any Entity that is not a Related Entity, provided that the group of any such Related Entities is primarily engaged in a business other than that of a Financial Institution;',
  },
  {
    code: '07',
    description:
      'Any NFFE is a ‘non for profit’ organization which meets all of the following requirements:\n\n–           It is established and operated in its jurisdiction of residence exclusively for religious, charitable, scientific, artistic, cultural, athletic, or educational purposes; or it is established and operated in its jurisdiction of residence and it is a professional organization, business league, chamber of commerce, labor organization, agricultural or horticultural organization, civic league or an organization operated exclusively for the promotion of social welfare;\n\n–           It is exempt from income tax in its jurisdiction of residence;\n\n–           It has no shareholders or members who have a proprietary or beneficial interest in its income or assets;\n\n–           The applicable laws of the NFFE’s jurisdiction of residence or the NFFE’s formation documents do not permit any income or assets of the NFFE to be distributed to, or applied for the benefit of, a private person or non-charitable Entity other than pursuant to the conduct of the NFFE’s charitable activities, or as payment of reasonable compensation for services rendered, or as payment representing the fair market value of property which the NFFE has purchased; and\n\nThe applicable laws of the NFFE’s jurisdiction of residence or the NFFE’s formation documents require that, upon the NFFE’s liquidation or dissolution, all of its assets be distributed to a governmental entity or other non-profit organization, or escheat to the government of the NFFE’s jurisdiction of residence or any political subdivision thereof.\n\nExplanation.- For the purpose of this sub-clause, the following shall be treated as fulfilling the criteria provided in the said sub-clause, namely:-\n\n(I)        an Investor Protection Fund referred to in clause (23EA);\n\n(II)       a Credit Guarantee Fund Trust for Small Industries referred to in clause 23EB; and\n\n(III)     an Investor Protection Fund referred to in clause (23EC), of section 10 of the Act;',
  },
];

export const nFENoTinReasonInfo = [
  {
    code: 'Reason A',
    description:
      'The country where the Account Holder is liable to pay tax does not issue TINs to its residents.',
  },
  {
    code: 'Reason B',
    description:
      'The Account Holder is unable to obtain a TIN or equivalent number. (If this reason is selected, please explain why the Account Holder is unable to obtain a TIN in the box beside)',
  },
  {
    code: 'Reason C',
    description:
      'No TIN is required because the tax residence jurisdiction that issued the TIN does not require a Financial Institution to collect and report the TIN',
  },
];
export const FatcaNonIndividualInfo: {
  key: string;
  header: string;
  infoMasters: { code: string; description: string }[];
}[] = [
  {
    key: 'exemptionCodeForUS',
    header: '',
    infoMasters: exemptionCodeForUSInfo,
  },
  {
    key: 'giinNotRequiredCode',
    header: '',

    infoMasters: giinNotRequiredCodeInfo,
  },
  {
    key: 'nFFECategory',
    header: '',
    infoMasters: nFFECategoryInfo,
  },
  {
    key: 'nFENoTinReason',
    header:
      '*If a TIN is unavailable, please provide the appropriate reason A, B or C as defined below:',
    infoMasters: nFENoTinReasonInfo,
  },
];

export const AdvisoryServices: { [key: string]: string } = {
  notAvailingAdvisory:
    'I/We am/are NOT availing any investment advisory services from any of the group entities of Referral partner',
  availingAdvisory:
    'I/We am/are availing investment advisory services from the group entities of Referral partner',
};

export const COMMENT_ROLES: { [key: string]: string } = {
  rm: 'RM',
  distributor: 'Distributor',
  subdistributor: 'Sub Distributor',
  amcapprover: 'AIF Approver',
  poaapprover: 'POA Approver',
};

export const UserFundsMaster: { [key: string]: string } = {
  pending: 'Pending',
  rejected: 'Rejected',
  approved: 'Approved',
};

export const initialComment = 'New entry';

export const POA_Authorized_signatory_can_Esign_Enable = true;

export const POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE = true;

export const DOCUMENT_ALLOW_PASTE = false;

export const ENABLE_REFRESH_LOGOUT = true;

export const CML_BANK_SAME_AS_DEBIT_TEXT =
  'Bank account from where funds are debited is same as CML bank account.';

export const InvalidCommentsMessage = `Invalid value [special characters are not allowed except  ,.-_'"]`;
export const YES_NO_BOOLEAN_MASTER: { [key: string]: string } = {
  true: 'Yes',
  false: 'No',
};

export const ENABLE_USER_EXPORT = true;

export const IndexToQuestionMapping: { [key: string]: string[] } = {
  '0': ['Q6.1.6', 'Q6.1.7', 'Q6.1.4'],
  '1': ['Q6.2.2', 'Q6.1.7'],
  '2': ['Q6.2.5', 'Q6.2.6'],
  '3': ['Q6.3.2', 'Q6.1.7'],
  '4': ['Q9.1.6', 'Q9.1.7', 'Q9.1.4'],
  '5': ['Q9.2.2', 'Q9.1.7'],
  '6': ['Q9.2.5', 'Q9.2.6'],
  '7': ['Q9.3.2', 'Q9.1.7'],
};

export const QuestionToIndexMapping: { [key: string]: number } = {
  'Q6.1.6': 0,
  'Q6.1.7': 0,
  'Q6.2.2': 1,
  'Q6.2.4': 2,
  'Q6.2.5': 2,
  // 'Q6.2.6': 2,
  'Q6.3.2': 3,
  'Q9.1.6': 4,
  'Q9.1.7': 4,
  'Q9.2.2': 5,
  'Q9.2.4': 6,
  'Q9.2.5': 6,
  // 'Q9.2.6': 6,
  'Q9.3.2': 7,
};

export const tinCode: { [key: string]: string } = {
  TIN: 'T',
  CIN: 'D',
  GIIN: 'Q',
  GEIN: 'N',
  Others: 'D',
  OTHERS: 'D',
};

export const docInvalidCheck =
  'Please upload a file that meets the size and format requirements, and ensure it is not password protected.';

export const PHONE_VALIDATION_MESSAGE = 'Phone number must contain 10 digits.';
export const EMAIL_VALIDATION_MESSAGE =
  'Please enter a valid email format (e.g., abc@example.com).';
